import Box from '@mui/material/Box'
import type { SxProps, Theme } from '@mui/material/styles'
import { classificacaoIconUrl, PROPORCAO_DO_ICONE, type ClassificacaoFrotaLeve } from '../classificacaoFrotaLeve'

/** O desenho da classificação da frota leve (20/10/2026), o mesmo do marcador do
 *  Mapa, centrado numa caixa de altura `size`. O texto alternativo vem de quem chama,
 *  já traduzido. */
export function ClassificacaoIcon({ classe, rotulo, size = 22, sx }: {
  classe: ClassificacaoFrotaLeve
  rotulo: string
  size?: number
  sx?: SxProps<Theme>
}) {
  return (
    <Box
      component="img"
      src={classificacaoIconUrl(classe)}
      alt={rotulo}
      title={rotulo}
      draggable={false}
      sx={{
        width: Math.round(size * PROPORCAO_DO_ICONE), height: size, objectFit: 'contain',
        flexShrink: 0, verticalAlign: 'middle', ...sx,
      }}
    />
  )
}
